"use client";

import { useId } from "react";
import { Text } from "@astryxdesign/core/Text";

type LeadFormMessageFieldProps = {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  rows?: number;
  isOptional?: boolean;
};

export function LeadFormMessageField({
  label = "Комментарий",
  value,
  onChange,
  placeholder = "Задача, объём, сроки…",
  rows = 3,
  isOptional = true,
}: LeadFormMessageFieldProps) {
  const id = useId();

  return (
    <label htmlFor={id} className="flex w-full flex-col gap-1.5">
      <Text as="span" size="sm" color="primary">
        {label}
        {isOptional ? (
          <Text as="span" size="sm" color="secondary">
            {" "}
            · необязательно
          </Text>
        ) : null}
      </Text>
      <textarea
        id={id}
        name="message"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        rows={rows}
        placeholder={placeholder}
        toolparamdescription="Кратко: задача, объём, сроки или контекст заявки"
        className="w-full resize-y rounded-md border border-border bg-surface px-3 py-2 text-sm leading-normal text-primary outline-none transition-[border-color,box-shadow] placeholder:text-secondary focus:border-[var(--color-accent)] focus:ring-2 focus:ring-[var(--color-accent)]/20"
      />
    </label>
  );
}
